// @flow
import type {Element} from 'react'
import React, {useMemo} from 'react'
import classNames from 'classnames'

import linkifyCustomProtocols from 'utils/MiscUtils/linkifyCustomProtocols'
import CKEditor from 'components/ui/CKEditor'
import styles from './index.scss'

export type Props = $ReadOnly<{
  value: string,
  dark?: boolean,
  supportMultiple?: boolean,
}>

function WYSIWYGViewer({
  value,
  dark,
  supportMultiple,
}: Props): Element<"div"> {
  const containerClassname = classNames(styles.container, {
    [styles.containerDark]: !!dark,
    [styles.listItem]: supportMultiple,
  })

  const linkifiedValue = useMemo(
    () => linkifyCustomProtocols(value, 'WYSIWYG'),
    [value],
  )

  return (
    <div className={containerClassname}>
      <CKEditor
        mode="classic"
        value={linkifiedValue}
        disabled
        useCustomCopyHandler={supportMultiple}
      />
    </div>
  )
}

WYSIWYGViewer.defaultProps = {
  value: '',
}

export default WYSIWYGViewer
